import { render, staticRenderFns } from "./SentimentHot.vue?vue&type=template&id=44ea41cc&scoped=true"
import script from "./SentimentHot.vue?vue&type=script&lang=js"
export * from "./SentimentHot.vue?vue&type=script&lang=js"
import style0 from "./SentimentHot.vue?vue&type=style&index=0&id=44ea41cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ea41cc",
  null
  
)

export default component.exports